import { newAxiosIns } from '@/libs/axios'

const POLLING_INTERVAL_MS = 120000
let pollingTimeoutId = null
let isFetching = false

const clearPollingTimer = () => {
  if (!pollingTimeoutId) return
  clearTimeout(pollingTimeoutId)
  pollingTimeoutId = null
}

/** Vuex module — polls storage-request pending count for the nav badge. */
export default {
  namespaced: true,
  state: () => ({
    isPolling: false,
    total: 0,
  }),
  mutations: {
    SET_ALL_BADGE(state, value) {
      state.total = value.total
    },
    SET_POLLING_STATE(state, value) {
      state.isPolling = value
    },
  },
  actions: {
    async fetchStorageRequestCount({ commit }) {
      if (isFetching) return
      isFetching = true

      try {
        const { data } = await newAxiosIns.get('/komship/api/v1/submissions/pending/mitras')
        commit('SET_ALL_BADGE', data.data)
      } catch (error) {
        const message = error?.response?.data?.message
          || error?.message
          || 'Failed to fetch storage request count'
        console.error('[storage_request_count/fetchStorageRequestCount]', message)
      } finally {
        isFetching = false
      }
    },

    startPolling({ state, commit, dispatch }) {
      commit('SET_POLLING_STATE', true)
      clearPollingTimer()

      const run = async () => {
        await dispatch('fetchStorageRequestCount')

        if (!state.isPolling) return
        pollingTimeoutId = setTimeout(run, POLLING_INTERVAL_MS)
      }

      run()
    },

    stopPolling({ commit }) {
      commit('SET_POLLING_STATE', false)
      clearPollingTimer()
    },
  },
}
